/**
 * @template T Type of the input object
 * @template V Type of the value of the particular key, will be the same for all keys
 *
 * @see https://www.typescriptlang.org/docs/handbook/2/mapped-types.html
 */
export type ShallowClonedTypeFor<T, V> = {
  [Property in keyof T]: V;
};

export interface AddressStreetType {
  street1: string;
  street2?: string;
  state: string;
  city: string;
  country: string;
  postcode: string;
}

export interface CoordinatesType{
  lon: string,
  lat: string
}

export interface NewPasswordType {
  confirmPwd: string;
  password: string;
}

export type PhoneInputType = {
    dialCode: string,
    number?: string
}

export type DataListType = {
    label:string;
    value:string | React.ReactElement;
    link?:string;
    color?:"red" | "black";
}

export enum OrgType {
    OWNER = 'OWNER',
    LP = 'LOGISTIC_PROVIDER',
    COMPANY = 'COMPANY',
    CUSTOMER = "CUSTOMER",
}

export interface DefaultFilter {
  orgID?: string;
  [key: string]: string | boolean | (string | boolean)[] | undefined;
}

export interface Option {
    label:string;
    value:string;
}

export interface Pagination {
  offset: number;
  limit: number;
}

export interface Sorting {
  sortBy: string;
  mode: SortingMode;
}

export enum SortingMode {
  ASC = "ASC",
  DESC = "DESC",
  NEITHER = "",
}

export enum FileTypeFilePayload {
  IMAGE = "IMAGE",
  DOCUMENT = "DOCUMENT",
  VIDEO = "VIDEO",
}

export interface FilePayload {
  fileName: string;
  fileType: FileTypeFilePayload;
  base64String: string;
  file_url?: string;
}

export enum Day {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  everyday = "everyday",
}

export interface ModalType<T> {
  open: boolean;
  type: "restore" | "delete" | "reject" | "approve" | "deactivate" | "activate";
  record: T;
}

export interface TempDeleteInfoObjectType {
  tempDeleteInfo?: {
    /** true/false */
    tempDelete: boolean;
    /** eg: profiles/xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx */
    tempDeletedBy: string;
    /** eg: 2022-06-27T02:07:31.263Z */
    tempDeletedOn: string;
    /** eg: test delete 2 */
    tempDeletedReason: string;
  };
}

export interface ModalTranslationContent {
  title: string;
  sureTxt: string;
  contentToConfirm: string;
  actionLabel: string;
}

export interface OrgList {
  orgName: string | null;
  orgID: string;
}

export type Breakpoint = "xxl" | "xl" | "lg" | "md" | "sm" | "xs";

export type Column = {
    title: React.ReactNode | string;
    dataIndex: string | string[];
    width?: string | number;
    ellipsis?: boolean;
    responsive?: Breakpoint[];
    render?: any;
    onCell?: any;
}

export enum Statuses {
    PENDING = "PENDING",
    APPROVED = 'APPROVED',
    UNAPPROVED = 'UNAPPROVED',
    REJECTED = 'REJECTED',
    ACTIVATE = "ACTIVATE",
    DEACTIVATE = "DEACTIVATE",
    DELETE = "DELETE",
    RESTORE = "RESTORE",
}

export enum AccountRole {
    OWNER = "OWNER",
    LOGISTIC_PROVIDER = "LOGISTIC_PROVIDER",
    COMPANY = "COMPANY",
    CUSTOMER = "CUSTOMER",
}

export interface Option {
  label: string;
  value: string;
}

export interface PrefilledForms {
  version: number; 
  active: boolean;
  maxWeight: string;
  surcharge: {
    fixedAmount: string;
    percentage: string;
  };
  validFrom: {
    date: null,
    dateString: string,
    
  },
  validTo: {
    date: null,
    dateString: string,
  },
  maxDimension: {
    length: string;
    width: string;
    height: string;
  };
}

export interface NavigationInterface {
  label: JSX.Element;
  href: string;
  roles?: string[];
  icon?: JSX.Element;
  isActive?: boolean,
  includeOnly?: string;
  exclude?: string[];
  children?: NavigationInterface[];
}